import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class BusinessNavSessionService {
  private sessionIdSubject$$: ReplaySubject<string> = new ReplaySubject<string>(1);
  public sessionId$: Observable<string> = this.sessionIdSubject$$.asObservable();

  setSessionId(sessionId: string): void {
    this.sessionIdSubject$$.next(sessionId);
  }
}
